module.exports = function(app) {
	'use strict';
	app.directive('eprAct4', function () {
		return {

			template: require('directives/employee/eprAct4.html'),
			restrict: 'A',
			replace: true,

			scope: {
				employee: '=eprAct4',
				groupNumber: '=?',
				productEffectiveDate: '=?',
				editMode: '=?'
			},

			controller: ['$scope', '$filter', 'services', 'employee', 'storage', function ($scope, $filter, services, employee, storage) {
				// groupNumber is optional, it's being passed in on the add flow, because medical plan could be changing, so we need to work with a dynamic group number
				// This seems odd, because a value passed in via an attirbute is not dynamic, but the add flow uses an ng-if outside of this directive to handle that
				// For the edit flow, groupNumber won't be passed in, we'll just detect it from the subscribers medical product
				var groupNumberCheck = $scope.groupNumber;
				if (!groupNumberCheck) {
					if (Array.isArray($scope.employee.data.subscriber.memberCoverages)) {
						for (var x = 0; x < $scope.employee.data.subscriber.memberCoverages.length; x++) {
							if (Array.isArray($scope.employee.data.subscriber.memberCoverages[x].memberLobs)) {
								for (var y = 0; y < $scope.employee.data.subscriber.memberCoverages[x].memberLobs.length; y++) {
									if ($scope.employee.data.subscriber.memberCoverages[x].memberLobs[y].coverageType.toLowerCase() == "medical") {
										groupNumberCheck = $scope.employee.data.subscriber.memberCoverages[x].groupNumber;
									}
								}
							}
						}
					}
				}


				var productEffectiveDate = $scope.productEffectiveDate
					? $filter('date')($scope.productEffectiveDate, 'yyyy-MM-dd')
					: services.eprsvc.additionalGroupInformation().getEffectiveDate(groupNumberCheck);

				$scope.allowAct4 = false;
				services.eprsvc.additionalGroupInformation({ groupNumber: groupNumberCheck }).fetch(productEffectiveDate).then(
					function(response) {
						var additionalGroupInformation = response && response.data && response.data.payload;
						if (additionalGroupInformation && additionalGroupInformation.parentalCrossLink) {
							$scope.allowAct4 = true;
						}
					},
					function() {
					}
				);

				$scope.$on('assignAct4', function() {
					if ($scope.allowAct4) {
						for (var x = 0; x < $scope.employee.data.subscriber.memberCoverages.length; x++) {
							if ($scope.employee.data.subscriber.memberCoverages[x].groupNumber === groupNumberCheck) {
								$scope.employee.data.subscriber.memberCoverages[x].parentalAgreementNumber = $scope.data.parentalAgreementNumber;
							}
						}
					}
					$scope.$emit('act4Assigned');
				});
				$scope.$watch('data.parentalAgreementNumber', function() {
					if ($scope.allowAct4) {
						employee.metadata.parentalAgreementNumber = $scope.data.parentalAgreementNumber;
					}
				});

				$scope.getAgreementNumber = function(groupNumber) {
					var parentalAgreementNumber = '';
					if (Array.isArray($scope.employee.data.subscriber.memberCoverages)) {
						for (var x = 0; x < $scope.employee.data.subscriber.memberCoverages.length; x++) {
							if (groupNumber && $scope.employee.data.subscriber.memberCoverages[x].groupNumber !== groupNumber) {
								continue;
							}
							parentalAgreementNumber = parentalAgreementNumber || $scope.employee.data.subscriber.memberCoverages[x].parentalAgreementNumber;
						}
					}
					return parentalAgreementNumber;
				};

				var storedNum = storage.get('parentalAgreementNumber');
				if (storedNum) {
					$scope.data = {
						parentalAgreementNumber: storedNum
					};
					storage.del('parentalAgreementNumber');
				}
				else {
					$scope.data = {
						parentalAgreementNumber: $scope.getAgreementNumber($scope.groupNumber) || null
					};
				}
			}]
		};
	});
};
